<div class="trans-catg-sync-container">
  <!-- Loading Overlay -->
  @if (loading) {
<div class="loading-overlay">
    <div class="loading-spinner-container">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
      <span class="loading-message">{{loadingMessage}}</span>
    </div>
  </div>
}

  <!-- Header Section -->
  <table class="gt-reclass-table table table-condensed">
    <thead>
      <tr>
        <th colspan="16" class="header-title">Transaction Category Sync Process</th>
      </tr>
    </thead>
  </table>

  <!-- Form Controls - All in one row with flexbox -->
  <div class="form-controls-row">
    <!-- Tax Year -->
    <div class="form-group-inline">
      <label class="control-label">Tax Year</label>
      <select 
        id="FTC_SSSYNC_UD_1"
        class="form-control"
        [(ngModel)]="selectedTaxYear"
        (ngModelChange)="getScenarioDropDown()">
        <option value="" disabled selected>Select Tax Year</option>
        @for (taxyr of filteredTaxYearData; track $index) {
<option 
         
          [value]="taxyr.CODE_DISP_DESC">
          {{taxyr.CODE_DISP_DESC}}
        </option>
}
      </select>
    </div>

    <!-- Scenario -->
    @if (showscenario) {
<div class="form-group-inline">
      <label class="control-label">Scenario</label>
      <select 
        id="FTC_IAPR_CD_12"
        class="form-control"
        [(ngModel)]="selectedScenario"
        (ngModelChange)="transCatgInfo()">
        <option value="" disabled selected>Select Scenario</option>
        @for (option of scenarioDropDown; track $index) {
<option 
         
          [value]="option.VALUE">
          {{option.LABEL}}
        </option>
}
      </select>
    </div>
}

    <!-- Trans Category -->
    @if (showTransCatg) {
<div class="form-group-inline">
      <label class="control-label">Trans Category</label>
      <select 
        id="FTC_IAPR_CD_13"
        class="form-control trans-catg-select"
        [(ngModel)]="selectedTransCatg">
        <option value="" disabled selected>Select Trans Category</option>
        @for (option of transCatgDetails; track $index) {
<option 
         
          [value]="option.TRANS_CATG_KEY">
          {{option.TRANS_CATG_NAME}}
        </option>
}
      </select>
    </div>
}

    <!-- Trans Catg Sync Button -->
    @if (showTransCatg) {
<div class="form-group-inline button-group">
      <button 
        id="FTC_SSSYNC_UD_8" 
        class="btn btn-info btn-sm sync-button"
        type="button"
        (click)="onTransCatgSyncClick()">
        Trans Catg Sync
      </button>
    </div>
}
  </div>

  <!-- Confirmation Modal -->
  @if (showConfirmModal) {
<div class="confirmation-modal-overlay">
    <gtw-confirmation-modal
      [config]="confirmModalConfig"
      [visible]="false"
      (confirmed)="onConfirmSync()"
      (cancelled)="onCancelConfirm()"
      (closed)="onCancelConfirm()">
    </gtw-confirmation-modal>
  </div>
}
</div>
